import defaultProfilePictureUrl from '@/assets/icons/default-profile.svg';

function userPictureUrl(pictureUrl:string|null) {
  return pictureUrl || defaultProfilePictureUrl;
}

export { userPictureUrl };
